import { createSearchParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ISummaryData, RoleType } from '../../../../../types';
import { VIEWS_MAP } from '../../../../../router/constants';
import useStore from '../../../../../store';
import { FEATURE_FLAG } from '../../../../../constants/general';
import { validateFeatureFlag } from '../../../../../services/featureFlagService';

export const useRoleSelectionPageLogic = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState<RoleType | null>(null);
  const { teamMembers }: ISummaryData = useStore((state) => state.summary);
  const allowAdminInvite = teamMembers.filter((member) => member.teamMemberType === RoleType.ADMIN).length < 3;
  const allowAccountantInvite =
    teamMembers.filter((member) => member.teamMemberType === RoleType.ACCOUNTANT).length < 1;
  const allowInviteAccountantPermission = validateFeatureFlag(FEATURE_FLAG.INVITE_ACCOUNTANT);
  const allowInviteAdminPermission = validateFeatureFlag(FEATURE_FLAG.INVITE_ADMIN);
  // @ts-ignore
  const learnMoreLink =
    // eslint-disable-next-line max-len
    'https://support.lili.co/hc/en-us/search/click?data=BAh7DjoHaWRsKwia1RFOiAY6D2FjY291bnRfaWRpA3GuJToJdHlwZUkiDGFydGljbGUGOgZFVDoIdXJsSSJvaHR0cHM6Ly9zdXBwb3J0LmxpbGkuY28vaGMvZW4tdXMvYXJ0aWNsZXMvNzE4MjQ5NTExMDU1NC1DYW4tSS1naXZlLW15LWFjY291bnRhbnQtYWNjZXNzLXRvLW15LUxpbGktYWNjb3VudAY7CFQ6DnNlYXJjaF9pZEkiKTE2YTM3ZWU3LTllMDQtNDkyOC05ZmVjLTk0MzJkOTVhZDVkNgY7CEY6CXJhbmtpBjoLbG9jYWxlSSIKZW4tdXMGOwhUOgpxdWVyeUkiD2FjY291bnRhbnQGOwhUOhJyZXN1bHRzX2NvdW50aQGA--8b5f44703620c9128dfb295768a96574b69ede73';
  const onSelectRole = (role: RoleType) => {
    if (role === selectedRole) {
      setSelectedRole(null);
    } else {
      setSelectedRole(role);
    }
  };

  const onSubmit = () => {
    if (!selectedRole) {
      return;
    }
    navigate({
      pathname: `/${VIEWS_MAP.INVITE_ACCOUNTANT.INVITE}/${VIEWS_MAP.INVITE_ACCOUNTANT.DETAILS}`,
      search: createSearchParams({ role: selectedRole }).toString(),
    });
  };

  return {
    selectedRole,
    onSelectRole,
    onSubmit,
    allowAdminInvite,
    showAdminOption: allowInviteAdminPermission,
    allowAccountantInvite,
    showAccountantOption: allowInviteAccountantPermission,
    learnMoreLink,
  };
};
